var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { PaidDetailsComponent } from "app/views/modal/paid_details/paid_details.component";
import * as moment from 'moment-timezone';
import merge from 'lodash-es/merge';
import { ChartParams } from "app/views/chart/chart.component";
import { HelperService } from "app/lib/helper.service";
import { ModalService } from "app/views/modal/base_modal.component";
import { BaseComponent } from "app/views/base.component";
import { EventsService } from "app/lib/EventsService";
import { RouteProvider } from "../../provider/route.provider";
import { BillingService2 } from "../billing.service";
var PeriodData = /** @class */ (function () {
    function PeriodData() {
        this.count = 0;
        this.siteIds = [];
    }
    return PeriodData;
}());
var Periods = /** @class */ (function () {
    function Periods() {
        this['month'] = new PeriodData();
        this['3months'] = new PeriodData();
        this['6months'] = new PeriodData();
        this['12months'] = new PeriodData();
        this['24months'] = new PeriodData();
        this['gt24months'] = new PeriodData();
        this['total'] = new PeriodData();
    }
    return Periods;
}());
var MonthData = /** @class */ (function () {
    function MonthData() {
        this.disabled = new Periods();
        this.manualPaid = new Periods();
        this.off = new Periods();
        this.paid = new Periods();
        this.paidAlive = new Periods();
        this.recurrent = new Periods();
        this.recurrentOff = new Periods();
        this.strange = new Periods();
        this.waitForPaid = new Periods();
    }
    return MonthData;
}());
var ExpiredPaidData = /** @class */ (function () {
    function ExpiredPaidData() {
        this.opened = false;
        this.data = new MonthData();
    }
    return ExpiredPaidData;
}());
var ExpiredPaidComponent = /** @class */ (function (_super) {
    __extends(ExpiredPaidComponent, _super);
    function ExpiredPaidComponent(translate, eventsService, activatedRoute, filter, modalService, routeProvider, helper, service2) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.translate = translate;
        _this.eventsService = eventsService;
        _this.activatedRoute = activatedRoute;
        _this.filter = filter;
        _this.modalService = modalService;
        _this.routeProvider = routeProvider;
        _this.helper = helper;
        _this.service2 = service2;
        _this.settings = {
            'paid': {
                i18n: 'adminstat.billing.expired_paid.paid',
                isHidden: false
            },
            'off': {
                i18n: 'adminstat.billing.expired_paid.Falls',
                isHidden: true
            },
            'paidAlive': {
                i18n: 'adminstat.billing.expired_paid.living',
                isHidden: false
            },
            'disabled': {
                i18n: 'adminstat.billing.expired_paid.unsubscribed',
                isHidden: true
            },
            'waitForPaid': {
                i18n: 'adminstat.billing.expired_paid.expected recurents',
                isHidden: true
            },
            'recurrent': {
                i18n: 'adminstat.billing.expired_paid.recurents',
                isHidden: true
            },
            'recurrentOff': {
                i18n: 'adminstat.billing.expired_paid.off recurents',
                isHidden: true
            },
            'manualPaid': {
                i18n: 'adminstat.billing.expired_paid.manual payments',
                isHidden: true
            },
            'strange': {
                i18n: 'adminstat.billing.expired_paid.strangers',
                isHidden: true
            }
        };
        _this.deathSitesChartData = new ChartParams();
        _this.paidAliveData = {};
        _this.paidAliveChartData = new ChartParams({
            names: {
                'Avg': _this.translate.__A('common.Avg'),
                'Avg2': _this.translate.__A('common.Avg2')
            }
        });
        _this.paidAliveChartValue = 'relative';
        _this.expiredChartData = new ChartParams();
        _this.expiredData1 = ['Выжило'];
        _this.expiredData2 = ['Отвалилось'];
        _this.expiredChartPeriod = 'total';
        _this.expiredChartValue = 'absolute';
        _this.cumLtvChartData = new ChartParams();
        _this.monthsList = [];
        _this.months = [];
        _this.fallenLoader = false;
        _this.paidsByMonthsLoader = false;
        _this.paidsByNumLoader = false;
        _this.expiredChartPercentLoader = 100;
        _this.moment = moment;
        _this.addFilterParams = {
            userType: 'user',
            isExpiredPaid: true,
            dateFilters: ['datePaid', 'dateCreated', 'dateSiteCreated']
        };
        return _this;
    }
    ExpiredPaidComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPaidAlive()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getDeathSites()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getMonths()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.getPaidsByMonth()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.getPaidsByNum()];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, this.getCumLtvData()];
                    case 6:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredPaidComponent.prototype.getPaidAlive = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.paidAliveChartData.showLoader();
                        this.paidAliveChartData.setOptions({
                            showLabels: [
                                'Avg2'
                            ],
                            title: this.translate.__A('billing.expired_paid.By paidalive'),
                            grid: {
                                y: {
                                    lines: [{ value: 0 }]
                                }
                            },
                            axis: {
                                x: {
                                    type: 'category',
                                    categories: this.paidAliveData.categories,
                                    tick: {
                                        culling: {
                                            max: 20
                                        }
                                    },
                                    label: {
                                        text: this.translate.__A('billing.expired_paid.firstPaidMonth'),
                                        position: 'outer-middle'
                                    }
                                },
                                y: {
                                    label: {
                                        text: this.translate.__A('billing.expired_paid.aliveSitesPercent'),
                                        position: 'outer-middle'
                                    }
                                }
                            },
                            lazyRender: true,
                        });
                        _a = this;
                        return [4 /*yield*/, this.service2.expiredPaid.get(this.filter.filterParams, 'paidalive').toPromise()];
                    case 1:
                        _a.paidAliveData = _b.sent();
                        this.paidAliveChartData.data = this.paidAliveData.relativeValues;
                        this.paidAliveChartData.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredPaidComponent.prototype.getDeathSites = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.deathSitesChartData.showLoader();
                        return [4 /*yield*/, this.service2.expiredPaid.get(this.filter.filterParams, 'death_sites').toPromise()];
                    case 1:
                        data = _a.sent();
                        this.deathSitesChartData.data = data.values;
                        this.deathSitesChartData.setOptions({
                            title: this.translate.__A('billing.expired_paid.dead sites chart'),
                            grid: {
                                y: {
                                    lines: [{ value: 0 }]
                                }
                            },
                            axis: {
                                x: {
                                    type: 'category',
                                    categories: data.categories,
                                    tick: {
                                        culling: {
                                            max: 20
                                        }
                                    }
                                }
                            }
                        });
                        this.deathSitesChartData.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredPaidComponent.prototype.getMonths = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, stats, i, tick, _i, _a, month, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        me = this;
                        me.months = [];
                        if (me.filter.filterParams.isShowExpiredPaidAddFields) {
                            Object.keys(me.settings).forEach(function (field) {
                                me.settings[field].isHidden = false;
                            });
                        }
                        else {
                            Object.keys(me.settings).forEach(function (field) {
                                if (field === 'paid' || field === 'paidAlive') {
                                    me.settings[field].isHidden = false;
                                }
                                else {
                                    me.settings[field].isHidden = true;
                                }
                            });
                        }
                        me.fallenLoader = true;
                        return [4 /*yield*/, me.service2.expiredPaid.stats(me.filter.filterParams, 'fall/dates').toPromise()];
                    case 1:
                        stats = (_b.sent()).stats;
                        me.monthsList = stats;
                        me.fallenLoader = false;
                        me.expiredChartPercentLoader = 0;
                        i = 0;
                        tick = 100 / me.monthsList.length;
                        _i = 0, _a = me.monthsList;
                        _b.label = 2;
                    case 2:
                        if (!(_i < _a.length)) return [3 /*break*/, 5];
                        month = _a[_i];
                        return [4 /*yield*/, me.service2.expiredPaid.get(me.filter.getCopyFilterParams({ month: month }), 'fall/month').toPromise()];
                    case 3:
                        data = _b.sent();
                        me.months.push(merge({}, new ExpiredPaidData(), {
                            month: moment(month).tz('Europe/Moscow').format('01.MM.YYYY'),
                            data: data,
                        }));
                        me.expiredChartPercentLoader = Math.ceil(i * tick);
                        i++;
                        _b.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        me.expiredChartPercentLoader = 100;
                        me.setExpiredChartData();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredPaidComponent.prototype.getCumLtvData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service2.expiredPaid.chart(this.filter.filterParams, 'cum_ltv').toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.cumLtvChartData.data = charts;
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredPaidComponent.prototype.setExpiredChartData = function () {
        var me = this;
        me.expiredChartData.showLoader();
        me.monthsList = [];
        me.expiredData1 = ['paidAlive'];
        me.expiredData2 = ['off'];
        for (var _i = 0, _a = me.months; _i < _a.length; _i++) {
            var month = _a[_i];
            me.monthsList.push(month.month);
            var paid = typeof month.data.paidAlive[me.expiredChartPeriod] != 'undefined' ? month.data.paidAlive[me.expiredChartPeriod].count : 0;
            var off = typeof month.data.off[me.expiredChartPeriod] != 'undefined' ? month.data.off[me.expiredChartPeriod].count : 0;
            if (me.expiredChartValue == 'relative') {
                var total = paid + off;
                paid = (100 * paid / total).toFixed(0);
                off = (100 * off / total).toFixed(0);
            }
            me.expiredData1.push(paid);
            me.expiredData2.push(off);
        }
        me.expiredChartData.setOptions({
            type: 'bar',
            grid: {
                y: {
                    lines: [{ value: 0 }]
                }
            },
            axis: {
                x: {
                    type: 'category',
                    categories: me.monthsList,
                    tick: {
                        culling: {
                            max: 3
                        }
                    }
                }
            },
            groups: ['paidAlive', 'off'],
            events: {
                onclick: function (_a) {
                    var id = _a.id, index = _a.index;
                    return __awaiter(this, void 0, void 0, function () {
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, me.showExpiredChartDetail(me.monthsList[index], me.months[index].data[id][me.expiredChartPeriod].siteIds)];
                                case 1:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    });
                }
            },
            names: {
                paidAlive: 'Выжило',
                off: 'Отвалилось',
            },
        });
        me.expiredChartData.data = [me.expiredData1, me.expiredData2];
        me.expiredChartData.hideLoader();
    };
    ExpiredPaidComponent.prototype.changeExpiredChartPeriod = function (period) {
        if (this.expiredChartPeriod == period) {
            return true;
        }
        this.expiredChartPeriod = period;
        this.setExpiredChartData();
    };
    ExpiredPaidComponent.prototype.changeExpiredChartValue = function (value) {
        if (this.expiredChartValue == value) {
            return true;
        }
        this.expiredChartValue = value;
        this.setExpiredChartData();
    };
    ExpiredPaidComponent.prototype.changePaidAliveChartValue = function (value) {
        if (this.paidAliveChartValue == value) {
            return true;
        }
        this.paidAliveChartValue = value;
        if (value == 'absolute') {
            this.paidAliveChartData.data = this.paidAliveData.absoluteValues;
        }
        else {
            this.paidAliveChartData.data = this.paidAliveData.relativeValues;
        }
    };
    ExpiredPaidComponent.prototype.showTableRow = function (month, period) {
        if (period !== 'total') {
            return true;
        }
        month.opened = !month.opened;
    };
    ExpiredPaidComponent.prototype.showRowDetails = function (siteIds, month) {
        return __awaiter(this, void 0, void 0, function () {
            var modalRef, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (siteIds.length === 0) {
                            return [2 /*return*/, true];
                        }
                        modalRef = this.modalService.open(PaidDetailsComponent, {
                            title: month,
                            params: this.filter.filterParams,
                        }, { size: 'hg' });
                        return [4 /*yield*/, this.service2.siteBilling.detail(this.filter.getCopyFilterParams({ siteIds: siteIds, })).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        modalRef.componentInstance.details = stats;
                        console.log('details', modalRef.componentInstance.details);
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredPaidComponent.prototype.getPaidsByMonth = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.paidsByMonthsLoader = true;
                        _a = this;
                        return [4 /*yield*/, this.service2.expiredPaid.get(this.filter.filterParams, 'month').toPromise()];
                    case 1:
                        _a.paidByMonthData = _b.sent();
                        this.paidsByMonthsLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredPaidComponent.prototype.getPaidsByNum = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.paidsByNumLoader = true;
                        _a = this;
                        return [4 /*yield*/, this.service2.expiredPaid.get(this.filter.filterParams, 'paid_num').toPromise()];
                    case 1:
                        _a.paidByNumData = _b.sent();
                        this.paidsByNumLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredPaidComponent.prototype.createRange = function (number) {
        var items = [];
        for (var i = 1; i <= number; i++) {
            items.push(i);
        }
        return items;
    };
    ExpiredPaidComponent.prototype.reportDateTypeChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        return [4 /*yield*/, me.routeProvider.navigate(me.filter.getApplyFilters(me.filter.filterParams))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExpiredPaidComponent.prototype.showExpiredChartDetail = function (month, siteIds) {
        return __awaiter(this, void 0, void 0, function () {
            var modalRef, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (siteIds.length === 0) {
                            return [2 /*return*/, true];
                        }
                        modalRef = this.modalService.open(PaidDetailsComponent, {
                            title: month,
                            params: this.filter.filterParams,
                        }, { size: 'hg' });
                        return [4 /*yield*/, this.service2.siteBilling.detail(this.filter.getCopyFilterParams({ siteIds: siteIds, })).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        modalRef.componentInstance.details = stats;
                        return [2 /*return*/];
                }
            });
        });
    };
    return ExpiredPaidComponent;
}(BaseComponent));
export { ExpiredPaidComponent };
